module.exports = __webpack_public_path__ + "img/通告.c146121a.png";